import waterfall from "../waterfall.vue";
export default {
    components: {
        waterfall,
    },
    data() {
        return {
            //瀑布流
            masnory: null,
            updateId: 0,
            works: [],
            el: null,
            loading: true,
        };
    },
    methods: {
        clearWaterfall() {
            this.works = [];
            this.masnory.items = [];
            this.masnory.layout();
        },
        //更新目标瀑布流数据并布局
        updateWaterfall({ works, noCache, callback }) {
            if (!works || works.length == 0) {
                this.nowork = true;
                this.loading = false;
                return Promise.resolve();
            } else {
                this.nowork = false;
            }
            this.works = [];
            let resolver = null;
            let createAddworkFunc = (updateId) => {
                //把当前updateId包一下
                let addWork = (i) => {
                    let item = works[i];
                    if (!item.author) {
                        item.author = "";
                    }
                    let imgEle = document.createElement("img");

                    imgEle.onload = () => {
                        if (updateId != this.updateId) return;
                        this.works.push(item);
                        this.$nextTick(() => {
                            this.masnory.layout();
                            this.masnory.appended(this.el.lastChild);
                        });

                        if (i == works.length - 1) {
                            resolver();
                            if (callback) callback();
                        }
                        if (i != works.length - 1) {
                            addWork(i + 1);
                        }
                    };
                    imgEle.onerror = () => {
                        console.log(i);
                        if (i == works.length - 1) {
                            resolver();
                            if (callback) callback();
                        }
                        if (i != works.length - 1) {
                            addWork(i + 1);
                        }
                    };
                    let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                    item.thumbSrc = thumbSrc;
                    // noCache
                    imgEle.setAttribute("src", thumbSrc);
                };
                return addWork;
            };
            this.updateId++;
            let addWork = createAddworkFunc(this.updateId);

            let prm = new Promise((resolve) => {
                resolver = resolve;
                this.$nextTick(() => {
                    this.masnory.layout();
                    this.$refs.con.style.opacity = 1;
                    addWork(0);
                });
            });
            prm.then(() => {
                setTimeout(() => {
                    this.masnory.layout();
                }, 200);
            });
            console.log(this.updateId);
            return prm;
        },
        updateWaterfall233({ works, noCache, callback }) {
            if (!works || works.length == 0) return Promise.resolve();
            let resolver = null;
            let createAddworkFunc = (updateId) => {
                //把当前updateId包一下
                let addWork = (i) => {
                    console.log(updateId);

                    let item = works[i];

                    if (!item.author) {
                        item.author = "";
                    }

                    let thumbSrc = window["GLOBAL"].PUBLIC_OSS_HOST + item.url + "thumb.png";
                    if (noCache) {
                        //禁止缓存
                        thumbSrc = thumbSrc + "?timestamp=" + new Date().getTime();
                        item.thumbSrc = thumbSrc;
                    }

                    this.works.push(item);
                    this.$nextTick(() => {
                        let domList = document.getElementsByClassName("mo-work--img");
                        let imgEle = domList[i];

                        imgEle.onload = () => {
                            console.log(updateId, this.updateId);
                            if (updateId != this.updateId) return;
                            imgEle.parentNode.parentNode.parentNode.style.visibility = null;
                            this.masnory.layout();
                            this.masnory.appended(this.el.lastChild);
                            if (i == works.length - 1) {
                                resolver();
                                if (callback) callback();
                                return;
                            }
                            addWork(i + 1);
                        };

                        imgEle.onerror = () => {
                            console.log(i);
                            if (i == works.length - 1) {
                                resolver();
                                if (callback) callback();
                                return;
                            }
                            addWork(i + 1);
                        };
                    });
                };
                return addWork;
            };
            this.updateId++;
            let addWork = createAddworkFunc(this.updateId);

            let prm = new Promise((resolve) => {
                resolver = resolve;
                this.$nextTick(() => {
                    this.masnory.layout();
                    addWork(0);
                });
            });
            prm.then(() => {
                this.masnory.layout();
            });
            return prm;
        },
        loadingEnd() {
            console.log("loadinnnnnn");
            this.loading = false;
        },
    },

    mounted() {
        console.log("$$$$$$$$$$$ worklist mounted");
        const Masonry = require("masonry-layout");
        //瀑布流
        // import("masonry-layout").then((
        //     Masnory
        // ) => {
        //     console.log('**********************')
        this.el = this.$refs[this.waterfallType] && this.$refs[this.waterfallType].$el;
        if (!this.el) return;
        this.masnory = new Masonry(this.$refs[this.waterfallType].$el, {
            // options
            itemSelector: ".user-mo-work",
            columnWidth: ".user-mo-waterfall--grid-sizer",
            gutter: ".user-mo-waterfall--gutter-sizer",
            transitionDuration: "0.45s",
            hiddenStyle: {
                transform: "translateY(-30px)",
                opacity: 0,
            },
            visibleStyle: {
                transform: "translateY(0px)",
                opacity: 1,
            },
        });
        this.updateWaterfall({ works: this.works, callback: this.loadingEnd });
        // })
    },
};
